@if (summary) {
  <!-- Keeps the page's last content clear of the fixed bar. -->
  <div class="sn-checkout-spacer" aria-hidden="true"></div>

  <section class="sn-checkout-bar" aria-label="Checkout" data-test="checkout-bar" [attr.data-mode]="summary.mode">
    <div class="sn-checkout-inner">
      <div class="sn-checkout-summary">
        <p class="sn-checkout-eyebrow">
          <span class="sn-checkout-step" aria-hidden="true">3</span>Checkout
        </p>
        <p class="sn-checkout-title" data-test="checkout-title">
          <strong>{{ summary.title }}</strong>
          @if (summary.interval) {
            <span class="sn-checkout-interval"> · {{ summary.interval }}</span>
          }
        </p>
        @if (summary.addOns.length) {
          <p class="sn-checkout-addons" data-test="checkout-addons">
            <i class="fas fa-puzzle-piece" aria-hidden="true"></i>
            <span>{{ summary.addOns.join(', ') }}</span>
          </p>
        }
      </div>

      <div class="sn-checkout-price" data-test="checkout-price">
        @if (summary.priceNow) {
          <p class="sn-checkout-amount">
            @if (summary.regularPrice) {
              <s class="sn-checkout-was" data-test="checkout-regular-price"><span class="visually-hidden">Regular price </span>{{ summary.regularPrice }}</s>
            }
            <span class="sn-checkout-now" data-test="checkout-price-now">{{ summary.priceNow }}</span>
            <span class="sn-checkout-due">due now</span>
          </p>
          @if (summary.thenText) {
            <p class="sn-checkout-then" data-test="checkout-then">{{ summary.thenText }}</p>
          }
        } @else if (summary.priceNote) {
          <p class="sn-checkout-note">{{ summary.priceNote }}</p>
        }
      </div>

      <div class="sn-checkout-actions">
        <button type="button" class="sn-checkout-clear" data-test="checkout-clear" (click)="clear.emit()">
          Clear selection
        </button>
        <button
          type="button"
          class="btn-cyber btn-cyber-primary sn-checkout-primary"
          data-test="checkout-primary"
          [disabled]="busy"
          [attr.aria-busy]="busy"
          (click)="primary.emit()"
        >
          @if (busy) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          } @else {
            <i class="fas {{ primaryIcon }} cyber-icon" aria-hidden="true"></i>
          }
          <span>{{ primaryLabel }}</span>
        </button>
      </div>
    </div>
  </section>
}
